import { useState, useEffect, useMemo } from 'react';

import { logoFrames, LogoSvg } from '@/ui-kit/loader/LogoSvg';
import { TLoaderProps } from '@/ui-kit/loader/Loader.types';

export function Loader({ size, interval = 250, label }: TLoaderProps) {
  const [currentSvgIndex, setCurrentSvgIndex] = useState(0);
  const currentSvg = useMemo(() => logoFrames[currentSvgIndex], [currentSvgIndex]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSvgIndex((prevIndex) => (prevIndex + 1) % logoFrames.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div
      className="flex flex-col items-center justify-center gap-3 h-full"
      role="progressbar"
      aria-label={label || 'loader'}
    >
      <LogoSvg size={size} color="#4f91ea">
        {currentSvg}
      </LogoSvg>
      {label && <span className="typo-body-regular-caption text-secondary">{label}</span>}
    </div>
  );
}
